import { GridRowHeightEnum } from "../../../@types/enumsGlobal";
import { KizViewPluginSettings } from "../../Dictionaries/Kiz/KizView/KizViewPluginSettings";
import { ScanBoxCreatePluginSettings } from "../../Dictionaries/Kiz/ScanModal/box/ScanBoxCreatePluginSettings";
import { ScanBoxGismtCreatePluginSettings } from "../../Dictionaries/Kiz/ScanModal/boxGismt/ScanBoxGismtCreatePluginSettings";
import { InvoiceItemGridPluginSettings } from "./InvoiceItem";

const InvoiceGridPluginSettings: IPluginSettings = {
    name: "Приходные накладные",
    mnemocode: "invoice_plugin",
    rowHeight: GridRowHeightEnum.normal,
    permission: "Invoice",
    columns: [
        {
            order: 0,
            propertyName: "idGlobal",
            propertyType: "string",
            displayName: "ИД",
            visibility: false,
            width: 200,
        },
        {
            order: 1,
            propertyName: "displayName",
            propertyType: "string",
            displayName: "Наименование",
            visibility: false,
            width: 200,
        },
        {
            order: 2,
            propertyName: "documentState",
            propertyType: "string",
            displayName: "Статус",
            visibility: true,
            width: 99,
        },
        {
            order: 3,
            propertyName: "supplierName",
            propertyType: "string",
            displayName: "Поставщик",
            visibility: true,
            width: 126,
        },
        {
            order: 4,
            propertyName: "mnemocode",
            propertyType: "string",
            displayName: "Номер",
            visibility: true,
            width: 149,
        },
        {
            order: 5,
            propertyName: "documentDate",
            propertyType: "date",
            displayName: "Дата",
            visibility: true,
            width: 100,
        },
        {
            order: 6,
            propertyName: "supplierDocNumber",
            propertyType: "string",
            displayName: "Номер накладной поставщика",
            visibility: true,
            width: 117,
        },
        {
            order: 7,
            propertyName: "supplierDocDate",
            propertyType: "date",
            displayName: "Дата накладной поставщика",
            visibility: true,
            width: 115,
        },
        {
            order: 8,
            propertyName: "storeName",
            propertyType: "string",
            displayName: "Склад",
            visibility: true,
            width: 108,
        },
        {
            order: 9,
            propertyName: "documentStateModified",
            propertyType: "datetime",
            displayName: "Дата смены статуса",
            visibility: false,
            width: 200,
        },
        {
            order: 10,
            propertyName: "supplierSum",
            propertyType: "number",
            displayName: "Сумма, пост.",
            visibility: true,
            width: 120,
        },
        {
            order: 11,
            propertyName: "supplierVatSum",
            propertyType: "number",
            displayName: "Сумма НДС, пост.",
            visibility: true,
            width: 119,
        },
        {
            order: 12,
            propertyName: "supplierSumIncVat",
            propertyType: "number",
            displayName: "Сумма с НДС, пост.",
            visibility: true,
            width: 131,
        },
        {
            order: 13,
            propertyName: "retailSum",
            propertyType: "number",
            displayName: "Сумма, розн.",
            visibility: true,
            width: 151,
        },
        {
            order: 14,
            propertyName: "retailVatSum",
            propertyType: "number",
            displayName: "Сумма НДС, розн.",
            visibility: true,
            width: 125,
        },
        {
            order: 15,
            propertyName: "retailSumIncVat",
            propertyType: "number",
            displayName: "Сумма с НДС, розн.",
            visibility: true,
            width: 120,
        },
        {
            order: 16,
            propertyName: "supplierBillDocNumber",
            propertyType: "string",
            displayName: "Счёт-фактура",
            visibility: true,
            width: 110,
        },
        {
            order: 17,
            propertyName: "supplierBillDocDate",
            propertyType: "date",
            displayName: "Дата счёт-фактуры",
            visibility: true,
            width: 100,
        },
        {
            order: 18,
            propertyName: "documentStatusKizs",
            propertyType: "string",
            displayName: "Схема Киз",
            visibility: true,
            width: 108,
        },
        {
            order: 19,
            propertyName: "pricingModelName",
            propertyType: "string",
            displayName: "Модель ценообразования",
            visibility: true,
            width: 112,
        },
        {
            order: 20,
            propertyName: "contractorName",
            propertyType: "string",
            displayName: "Аптека получатель",
            visibility: true,
            width: 132,
        },
        {
            order: 21,
            propertyName: "isAgentContract",
            propertyType: "boolean",
            displayName: "Агентский контракт",
            visibility: false,
            width: 100,
        },
        {
            order: 22,
            propertyName: "isMdlp702SchemeAllowed",
            propertyType: "boolean",
            displayName: "Схема 702?",
            visibility: false,
            width: 100,
        },
        {
            order: 23,
            propertyName: "dateCreated",
            propertyType: "datetime",
            displayName: "Дата создания",
            visibility: false,
            width: 200,
        },
        {
            order: 24,
            propertyName: "dateModified",
            propertyType: "datetime",
            displayName: "Дата изменения",
            visibility: false,
            width: 200,
        },
        {
            order: 25,
            propertyName: "dateDeleted",
            propertyType: "datetime",
            displayName: "Дата удаления",
            visibility: false,
            width: 200,
        },
        {
            order: 26,
            propertyName: "gosContractName",
            propertyType: "string",
            displayName: "ГК",
            visibility: false,
            width: 200,
        },
        {
            order: 27,
            propertyName: "programName",
            propertyType: "string",
            displayName: "Целевая программа",
            visibility: false,
            width: 200,
        },
        {
            order: 29,
            propertyName: "markingStatus",
            propertyType: "string",
            displayName: "Статус маркировки",
            visibility: false,
            width: 200,
        },
        {
            order: 30,
            propertyName: "isInternetOrder",
            propertyType: "boolean",
            displayName: "Интернет заказ",
            visibility: false,
            width: 200,
        },
        {
            order: 31,
            propertyName: "internetOrderDate",
            propertyType: "datetime",
            displayName: "Дата интернет заказа",
            visibility: false,
            width: 200,
        },
        {
            order: 32,
            propertyName: "internetOrderNumber",
            propertyType: "string",
            displayName: "Номер интернет заказа",
            visibility: false,
            width: 200,
        },
        {
            order: 33,
            propertyName: "customerName",
            propertyType: "string",
            displayName: "ФИО покупателя",
            visibility: false,
            width: 200,
        },
        {
            order: 34,
            propertyName: "customerPhone",
            propertyType: "string",
            displayName: "Телефон покупателя",
            visibility: false,
            width: 200,
        },
    ],
    detailsPlugins: [InvoiceItemGridPluginSettings, KizViewPluginSettings, ScanBoxCreatePluginSettings, ScanBoxGismtCreatePluginSettings],
};

export default InvoiceGridPluginSettings;
